export const handleResponse = (err: any, resp: any, resolve: (value: any) => void, reject: (value: any) => void) => {
    if (err) {
        reject(err);
    } else {
        let payload = JSON.parse(resp.Payload)
        // If code is between 200 and 299, it is a success and resolve
        if (payload.statusCode >= 200 && payload.statusCode < 300) {
            resolve(payload.body)
            return
        }
        // if code is between 400 and 499, it is a client error and reject
        if (payload.statusCode >= 400 && payload.statusCode < 500) {
            reject(payload.body)
            return
        }
        reject(payload.errorMessage || payload.body || "Unknown error")
    }
}